export { Label } from './Label'
